import React from 'react';
import Icon from '@atlaskit/icon/core/status-warning';
import { Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const ErrorIcon = (): React.JSX.Element => (
	<Text as="span">
		<Icon label="" color={token('color.icon.danger')} />
	</Text>
);

export default ErrorIcon;
